const _alertType = {
  success: 'bi bi-check-circle',
  info: 'bi bi-info-circle',
  warning: 'bi bi-exclamation-circle',
  danger: 'bi bi-x-circle',
};

// Tooltip
const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
const tooltipList = [...tooltipTriggerList].map((tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl));

// Toast
window.toast = function (type, message, count_show = 12) {
  const _alert_elem =
    `<div class="alert alert-` +
    type +
    ` alert-dismissible fade show mb-3" role="alert">
        <i class="` +
    _alertType[type] +
    `"></i> ` +
    message +
    `
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    </div>`;
  const _alert = $(_alert_elem);
  const _alert_count = $('#siteToast .alert').length;
  if (_alert_count > count_show) {
    $('#siteToast .alert')[0].remove();
  }
  $('#siteToast').append(_alert);
  _alert.stop().fadeIn(100).delay(5000).fadeOut(100);
};

$(document).on('click', '.main-notifications', async function (e) {
  e.preventDefault();
  const has_notifications = $(this).find('.main-notifications-number');
  if (has_notifications.length > 0) {
    await $.get('/account/thong-bao/mark-as-read-all');
    has_notifications.remove();
    const menu_badge = $('#notification_management > li .badge');
    if (menu_badge.length > 0) {
      menu_badge.remove();
    }
  }
});
